export default "__VITE_ASSET__CrRiikyG__"